import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalNotificationByManager {
  name: string;
  api_token: string;
}

export interface InternalNotificationByManagerDetaiInfor {
  errors: unknown;
  internalNotificationByManager: InternalNotificationByManager;
  isAuthenticated: boolean;
}

@Module
export default class InternalNotificationByManagerDetail
  extends VuexModule
  implements InternalNotificationByManagerDetaiInfor
{
  errors = {};
  internalNotificationByManager = {} as InternalNotificationByManager;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get InternalNotificationByManagerDetail() {
    return this.internalNotificationByManagerDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.INTERNAL_NOTIFICATION_BY_MANAGER_DETAIL_DATA](
    InternalNotificationByManager
  ) {
    this.internalNotificationByManagerDetailData =
      InternalNotificationByManager;
  }
  @Action
  [Actions.INTERNAL_NOTIFICATION_BY_MANAGER_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/internal/thongbaonoibo",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(
          Mutations.INTERNAL_NOTIFICATION_BY_MANAGER_DETAIL_DATA,
          data
        );
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
